<template>
  <!-- [sc-48893] Dettaglio in sola lettura di una riga degli elenchi -->
  <VueFinalModal
    :model-value="show"
    @update:model-value="$emit('update:show', $event)"
    :click-to-close="true"
    :esc-to-close="true"
    classes="documents-modal"
    content-class="dettaglio-modal-content"
  >
    <template #default>
      <button
        class="modal__close icons-button"
        @click="$emit('update:show', false)"
        title="Chiudi"
        type="button"
      >
        <i class="fa-solid fa-xmark"></i>
      </button>

      <h3 class="modal__title">{{ titolo }}</h3>

      <div v-if="loading" class="dettaglio-stato">
        <div class="spinner" role="status"></div>
        <p>Carico il dettaglio…</p>
      </div>

      <p v-else-if="!gruppi.length" class="dettaglio-stato">
        Nessun dato da mostrare.
      </p>

      <div v-else class="dettaglio-corpo">
        <section v-for="g in gruppi" :key="g.titolo" class="dettaglio-gruppo">
          <h4 class="dettaglio-gruppo__titolo">{{ g.titolo }}</h4>

          <div v-if="g.tabella" class="dettaglio-tabella">
            <table class="tbl">
              <thead>
                <tr>
                  <th v-for="c in g.tabella.colonne" :key="c">{{ c }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(r, i) in g.tabella.righe" :key="i">
                  <td v-for="(v, j) in r" :key="j">{{ v }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <dl v-else class="dettaglio-campi">
            <div v-for="c in g.campi" :key="c.label" class="dettaglio-campo">
              <dt>{{ c.label }}</dt>
              <dd>
                <a
                  v-if="c.link"
                  :href="c.link"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="custom-link"
                  >{{ c.valore }}</a
                >
                <template v-else>{{ c.valore }}</template>
              </dd>
            </div>
          </dl>
        </section>
      </div>

      <div class="modal-actions">
        <button
          class="secondary-btn"
          type="button"
          @click="$emit('update:show', false)"
        >
          Chiudi
        </button>
      </div>
    </template>
  </VueFinalModal>
</template>

<script>
import { VueFinalModal } from "vue-final-modal";

export default {
  name: "DettaglioModal",
  components: { VueFinalModal },
  props: {
    show: { type: Boolean, required: true },
    titolo: { type: String, default: "Dettaglio" },
    // [{ titolo, campi: [{ label, valore, link? }] } | { titolo, tabella }]
    gruppi: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
  },
  emits: ["update:show"],
};
</script>

<style>
.documents-modal .dettaglio-modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 720px;
  max-width: calc(100vw - 32px);
  max-height: calc(100vh - 32px);
  box-sizing: border-box;
  background: var(--modal-bg);
  color: var(--modal-text);
  border: 1px solid var(--modal-border);
  border-radius: 12px;
  box-shadow: var(--modal-shadow);
  padding: 1.5rem;
}

.dettaglio-modal-content .dettaglio-corpo {
  overflow-y: auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.dettaglio-modal-content .dettaglio-stato {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  padding: 2rem 0;
  color: #666;
}

.dettaglio-modal-content .dettaglio-gruppo__titolo {
  margin: 0 0 6px;
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: var(--modal-muted);
}

.dettaglio-modal-content .dettaglio-campi {
  margin: 0;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px 24px;
}

.dettaglio-modal-content .dettaglio-campo dt {
  font-size: 12px;
  color: var(--modal-muted);
}

.dettaglio-modal-content .dettaglio-campo dd {
  margin: 0;
  font-size: 14px;
  overflow-wrap: anywhere;
}

.dettaglio-modal-content .dettaglio-tabella {
  border: 1px solid var(--modal-border);
  border-radius: 4px;
}

.dettaglio-modal-content .dettaglio-tabella .tbl th,
.dettaglio-modal-content .dettaglio-tabella .tbl td {
  white-space: normal;
  padding: 8px 10px;
}

@media (max-width: 719px) {
  .documents-modal .dettaglio-modal-content {
    padding: 1rem;
  }

  .dettaglio-modal-content .dettaglio-campi {
    grid-template-columns: minmax(0, 1fr);
  }
}
</style>
